export default __webpack_public_path__ + "static/media/distributor.0debedf4.svg";